export const getState = () => ({
  giftCardOperators: [],
  giftCardAmounts: [],
});

export default Object.assign(getState(), { getState: getState });
